Your value from Counter passed through dialog : {{dialogCount}}<br>
Counter value coming from ng store: {{storeCount$ | async}}

Increment count <button (click)="increment()">by 1</button>
<button [mat-dialog-close]="dialogCount">close and send back new data</button>
<button (click)="close()">close without sending info</button>
<button mat-dialog-close>close without sending info with attr.</button>